<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">职能模块认知</span>
      <span class="zn-text-grey">会把内容解析到人选 职能模块认知里</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="font-size:16px;padding-bottom:10px;color:#444;">
        当前人选：{{radish.姓名}}（{{radish.公司}}）
      </div>
      <div v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="zn-content-item" v-if="company._id && radish.职能模块 && radish.职能模块.length > 0">
          <div class="zn-content-item" v-for="(field, k) in cateRenzhiFields" :key="k">
            <div class="zn-text-grey">{{ field.label }}：</div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2 }"
              :placeholder="field.placeholder"
              v-model="formData[field.value]">
            </el-input>
          </div>
        </div>
        <div v-else class="zn-content-item">
          <template v-if="!company._id">
            <div class="zn-text-grey" style="width: 120px">请填写正确的公司：</div>
            <el-input v-model="radish.公司" size="mini" @blur="searchCompany" style="width:300px"></el-input>
          </template>
          <div class="zn-text-grey" style="width: 120px">请填写职能模块：</div>
          <el-select size="mini" v-model="radish.职能模块" filterable multiple @change="changeCate" style="width:300px">
            <el-option v-for="(opt, k) in categories" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="zn-template-submit" @click="submit">完成填写</div>
    <el-dialog
      class="radish-dia"
      top="70px"
      width="400px"
      :modal="false"
      :visible.sync="chooseCateVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <div class="rpg-tip-red">该条信息会联动到相应的公司和职能模块，请确认</div>
        <div class="rpg-mgb-5">
          公司：<b>{{ radish.公司 }}</b> <span class="rpg-gray">（人选当前公司）</span>
        </div>
        <div class="rpg-mgb-5">职能模块：<span class="rpg-gray">（人选有多个职能模块，请选择其一）</span></div>
        <el-radio-group v-model="cateRenzhiCate" size="mini">
          <el-radio v-for="(cate, k) in radish.职能模块" :key="k" border :label="cate"></el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showChooseCompany"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="450px"
      class="radish-dia"
    >
      <div style="font-size:12px;color:#888;margin-bottom:5px">
        系统没有查到您填写的公司
        <span v-show="similarCompany.length > 0">，您要找到是不是以下公司，如果不是</span>
        <el-button type="text" size="mini"
          @click="gotoCompany"
          style="font-size:13px"
        >请新建</el-button>
      </div>
      <div class="radish-dia-body">
        <div style="padding-bottom:10px;">
          <el-button v-for="(com, k) in similarCompany" :key="k" type="text" size="mini"
            @click="chooseCompany(com.简称)"
            style="margin:0 20px 5px 0;font-size:13px"
          >
            {{com.公司名称}}({{com.简称}})
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {cateRenzhiFields} from './renzhi_fields'
export default {
  props: {
    componentName: String,
    item: Object,
  },
  data() {
    return {
      formData: {},
      cateRenzhiFields,
      submiting: false,
      radish: {},
      company: {},
      gouFields: [
        '意向', '关键标签', '诉求', '期望行业',
        '期望地域','期望职能','期望职级',
        '期望薪酬奖金', '理想公司', '目前薪酬职级',
        '离职周期', '最看重的点', '其他在接触的机会',
        '对人选的判断/匹配度','针对该人选下一步操作'
      ],
      cateRenzhis: [],
      cateRenzhiCate: '',
      chooseCateVisiable: false,
      showChooseCompany: false,
      similarCompany: [],
      categories: app.categories.map(category => category.名称) || [],
    }
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          localStorage.setItem(this.componentName+(this.$route.params.id||''), JSON.stringify(newVal))
        }
      },
      deep: true
    },
    $route: {
      handler: function(val, oldVal){
        if (val.params.id) {
          this.formData = {}
          this.initOther()
        } else {
          this.formData = {}
          this.$emit('closeTpl')
        }
      }
    }
  },
  methods: {
    async loadRadish() {
      const rid = this.item.rid || this.$route.params.id
      const res = await app.service('radish').simpleFetch({
        _id: rid, fields: { 姓名: 1, 公司: 1, 职能模块: 1 }
      })
      if (res.status == 'success' && res.data) {
        this.radish = res.data
      }
    },
    async submit() {
      this.chooseCateVisiable = false
      if (this.submiting) return this.$message('正在保存中，请稍候')
      if (Object.values(this.formData).every(dt=>(!dt || dt.length == 0))) return this.$message('您没有填写任何内容')
      if (!this.radish._id) return this.$message('没有人选数据')
      if (!this.company._id) return this.$message('没有公司数据')
      this.submiting = true
      if (this.radish._id) {
        if (this.company._id) {
          // 保存职能模块认知
          if (this.radish.职能模块 && this.radish.职能模块.length > 0) {
            this.showChooseCate()
            if (this.chooseCateVisiable) return this.submiting = false
          }
        }

        // 更新底层页面数据
        app.root.$refs.main.init && app.root.$refs.main.init()

        this.formData = {}
        localStorage.removeItem(this.componentName+(this.$route.params.id||''))
        this.submiting = false
        this.$emit('closeTpl', {msg: '小阿已为您保存完毕'})
      }
    },
    async loadCompany() {
      if (this.radish.公司) {
        const res = await app.service('company').getCompanySimpleList({
          query: { $or: [{ 公司名称: this.radish.公司 }, { 简称: this.radish.公司 }] },
          fields: { 简称: 1, 公司备注: 1, 阿尔法认知: 1 },
        })
        if (res.status == 'success') {
          if (res.data && res.data.length > 0) {
            this.company = res.data[0]
          }
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async loadComCateCognition() {
      if (this.company._id && this.radish.职能模块 && this.radish.职能模块.length > 0) {
        const res = await app.service('company').getComCateCognition(this.company._id)
        if (res.status === 'success') {
          const cateRenzhis = []
          this.radish.职能模块.forEach(zhi => {
            const item = res.data.find(dt => dt.职能模块 == zhi)
            if (item) {
              cateRenzhis.push(item)
            } else {
              cateRenzhis.push({ 公司: this.radish.公司, 职能模块: zhi })
            }
          })
          this.cateRenzhis = cateRenzhis
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    async saveCateRenzhiWord() {
      let cateRenzhiWord = ''
      this.cateRenzhiFields.forEach(item=>{
        if (this.formData[item.value]) {
          cateRenzhiWord += `${item.label}：${this.formData[item.value]}\n`
        }
      })
      if (!cateRenzhiWord) return
      if (!this.cateRenzhiCate) return this.$message('请选择职能模块')
      const toinsert = []
      const cateRenzhi = this.cateRenzhis.find(c => c.职能模块 == this.cateRenzhiCate)
      if (!cateRenzhi.logs) cateRenzhi.logs = []
      const saveLog = { createdAt: Date.now(), account: app.user.account, content: cateRenzhiWord }
      if(cateRenzhi._id){
        const res = await app.service('company').comCateCognitionAddLog({
          id: cateRenzhi._id,
          log: saveLog,
        })
        if (res.status === 'success') {
          cateRenzhiWord = ''
          this.cateRenzhiCate = ''
          localStorage[`cateRenzhiWord${this.company._id}`] = ''
          this.chooseCateVisiable = false
          this.loadComCateCognition()
        }
      }else{
        cateRenzhi.logs.unshift(saveLog)
        toinsert.push(cateRenzhi)
        const option = { toinsert }
        const res = await app.service('company').modifyComCateCognition({
          cid: this.company._id,
          option: option,
        })
        if (res.status === 200 || res.status === 'success') {
          cateRenzhiWord = ''
          this.cateRenzhiCate = ''
          this.$set(cateRenzhi,'logs',res.data)
          localStorage[`cateRenzhiWord${this.company._id}`] = ''
          this.chooseCateVisiable = false
          this.loadComCateCognition()
        } else {
          this.$message(res.msg)
        }
      }
    },
    showChooseCate() {
      if (this.cateRenzhiCate) {
        this.saveCateRenzhiWord()
      } else if (this.radish.职能模块 && this.radish.职能模块.length > 1) {
        this.chooseCateVisiable = true
      } else if (this.radish.职能模块 && this.radish.职能模块.length == 1) {
        this.cateRenzhiCate = this.radish.职能模块[0]
        this.saveCateRenzhiWord()
      } else {
        this.$message('请先填写人选职能模块')
      }
    },
    async searchCompany() {
      const hasCom = await app.service('company').checkHasCompany(this.radish.公司)
      if (hasCom.status == 'success' && hasCom.companyName) {
        this.radish.公司 = hasCom.companyName
        this.changeCompany()
      } else {
        const simiCom = await app.service('company').serchCompany(this.radish.公司)
        if (simiCom.status == 200) {
          this.similarCompany = simiCom.data
        }
        this.showChooseCompany = true
      }
    },
    chooseCompany(name) {
      this.showChooseCompany = false
      this.radish.公司 = name
      this.changeCompany()
    },
    async changeCompany() {
      await this.loadCompany()
      await this.loadComCateCognition()
      if (this.radish.公司) {
        await app.service('radish').modifyById({ _id: this.radish._id, data: {公司: this.radish.公司} })
      }
    },
    async changeCate() {
      await this.loadComCateCognition()
      if (this.radish.职能模块) {
        await app.service('radish').modifyById({ _id: this.radish._id, data: {职能模块: this.radish.职能模块} })
      }
    },
    async gotoCompany() {
      this.showChooseCompany = false
      window.open(`${window.origin}/#/NewAddCompany?companyName=${this.radish.公司}`, '_blank')
    },
    async initData(defaultForm) {
      this.formData = defaultForm || {}
      await this.initOther()
    },
    async initOther() {
      await this.loadRadish()
      await this.loadCompany()
      await this.loadComCateCognition()
      // console.log('init', this.radish, this.company)
    }
  }
}
</script>
